/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import {
  toggleLike,
  addComment,
  fetchComments,
  adjustCommentNumber
} from '@actions/courses';
import {
  TEXT,
  IMAGE,
  COURSE,
  CLASS,
  QUIZ,
  EDUCATOR,
  DOCUMENT,
  CLASS_RESCHEDULE,
  LEADERBOARD,
  PRACTICE_PUBLISHED,
  COURSE_EDIT
} from '@constants/modeltypes';
import { Spacings } from '@styles/index';
import { useDispatch } from 'react-redux';
import LikeComment from './LikeComment';
import NewClass from './NewClass';
import ClassRescheduledCard from './ClassRescheduledCard';
import DocumentCard from './DocumentCard';
import NewEducatorCard from './NewEducatorCard';
import NewCourseCard from './NewCourseCard';
import Leaderboard from './Leaderboard';
import ImageCard from './ImageCard';
import NewEmbeddedClassCard from './NewEmbeddedClassCard';
import EmbeddedQuizCard from './EmbeddedQuizCard';
import MessageCard from './MessageCard';
import PracticeCard from './PracticeCard';
import CourseEditCard from './CourseEditCard';

const Story = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 10;
  margin-top: ${Spacings.SPACING_14B};
  &:last-of-type {
    padding-bottom: 24px;
  }
`;

const StoryItem = ({
  story,
  selectedStory,
  channelId,
  setSelectedStory,
  batch,
  segmentData,
  onCloseUpdates
}) => {
  const dispatch = useDispatch();
  const { object_type, sub_type } = story;
  if (
    ![
      CLASS,
      CLASS_RESCHEDULE,
      DOCUMENT,
      COURSE_EDIT,
      TEXT,
      EDUCATOR,
      COURSE,
      LEADERBOARD,
      IMAGE,
      QUIZ,
      PRACTICE_PUBLISHED
    ].includes(object_type)
  )
    return null;
  if (
    !story.object.uid &&
    object_type !== TEXT &&
    object_type !== DOCUMENT &&
    object_type !== CLASS_RESCHEDULE &&
    object_type !== IMAGE &&
    object_type !== COURSE_EDIT
  )
    return null;
  const loadMoreComments = () => dispatch(fetchComments(story.uid, true));
  const updateLike = (uid, isLiked) =>
    dispatch(toggleLike(channelId, uid, isLiked));
  const postComment = (uid, text) => {
    dispatch(addComment(uid, text)).then(() => {
      dispatch(adjustCommentNumber(channelId, uid));
    });
  };
  const getComments = () => {
    dispatch(fetchComments(story.uid));
    setSelectedStory(story);
  };

  return (
    <Story>
      {object_type === PRACTICE_PUBLISHED && (
        <PracticeCard story={story} onCloseUpdates={onCloseUpdates} />
      )}
      {object_type === TEXT && <MessageCard batch={batch} story={story} />}
      {object_type === QUIZ && sub_type === 1 && (
        <NewClass batch={batch} story={story} />
      )}
      {object_type === QUIZ && sub_type !== 1 && (
        <EmbeddedQuizCard batch={batch} story={story} />
      )}
      {object_type === CLASS && sub_type === 1 && (
        <NewClass batch={batch} story={story} />
      )}
      {object_type === CLASS && sub_type !== 1 && (
        <NewEmbeddedClassCard batch={batch} story={story} />
      )}
      {object_type === CLASS_RESCHEDULE && (
        <ClassRescheduledCard batch={batch} story={story} />
      )}
      {object_type === COURSE_EDIT && <CourseEditCard story={story} />}
      {object_type === DOCUMENT && (
        <DocumentCard batch={batch} story={story} segmentData={segmentData} />
      )}
      {object_type === EDUCATOR && (
        <NewEducatorCard batch={batch} story={story} />
      )}
      {object_type === COURSE && <NewCourseCard batch={batch} story={story} />}
      {object_type === LEADERBOARD && (
        <Leaderboard batch={batch} story={story} />
      )}
      {object_type === IMAGE && <ImageCard batch={batch} story={story} />}
      <LikeComment
        toggleLike={updateLike}
        postComment={postComment}
        getComments={getComments}
        selectedStory={selectedStory}
        story={story}
        loadMoreComments={loadMoreComments}
      />
    </Story>
  );
};

export default StoryItem;
